import { endpointWrapper } from './meta.api';

export const getTsCategoryKeywords = async (config) =>
    endpointWrapper({
        domain: 'google/ts_category_keywords',
        ...config,
    });

export const getTsBrandKeywords = async (config) =>
    endpointWrapper({
        domain: 'google/ts_brand_keywords',
        ...config,
    });

export const getRelatedAffinitiesGoogleData = async (config) =>
    endpointWrapper({
        domain: 'google/related_affinities',
        ...config,
    });

export const getRelatedBrandsGoogleData = async (config) =>
    endpointWrapper({
        domain: 'google/related_brands',
        ...config,
    });
